// Mentors.jsx
import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import selvaIMG from "../../assets/mentors/selvaIMG.jpg";
import keerthanaIMG from "../../assets/mentors/keerthanaIMG.jpg";
import punithasriIMG from "../../assets/mentors/PUNITHASRI.jpg";
import rajaSelvakumarIMG from "../../assets/mentors/rajaSelvakumarIMG.jpg";
import userIMG from "../../assets/mentors/userIMG.jpg";

const mentors = [
  {
    id: 1,
    name: "Mr. R. Selva Ganapathy ",
    title: "Founder & Chief Mentor",
    bio: "Former Asst Commandant, ITBP. 15 years of experience in mentorship. Guides GS, Ethics, Interview, and Anthropology Optional.",
    image: selvaIMG,
    initials: "Mr. R. Selva Ganapathy",
  },
  {
    id: 2,
    name: "Mr. S. Raja SelvaKumar",
    title: "Senior Mentor",
    bio: "Senior Mentor with 15 years of experience. Specialist in Economy & Geography, known for exam-oriented teaching.",
    image: rajaSelvakumarIMG,
    initials: "Mr. S. RajaSelvam Kumar",
  },
  {
    id: 3,
    name: "Mr. K. Gopimoorthi",
    title: "GS mentor",
    bio: "Mentor with 8 years of experience as GS mentor. Expert in History & GS, also guides Tamil Literature Optional.",
    image: userIMG,
    initials: "Mr. K. Gopimoorthi",
  },
  {
    id: 4,
    name: "Mrs. G. Keerthana",
    title: "CSAT Mentor",
    bio: "CSAT Mentor with 8 years of experience. Former banker, simplifies Aptitude & Reasoning through practical methods.",
    image: keerthanaIMG,
    initials: "Mrs. G. Keerthana",
  },
  {
    id: 5,
    name: "Ms. U. Punitha Sri",
    title: "GS Mentor",
    bio: "Mentor with 8 years of experience as GS mentor. Specializes in History Optional & General Studies, known for her conceptual clarity and structured guidance for UPSC aspirants.",
    image: punithasriIMG,
    initials: "Ms. U. Punitha Sri",
  },

];

const MentorCard = ({ mentor }) => (
  <div className="min-w-[80%] sm:min-w-0 bg-white rounded-2xl shadow-md p-6 text-center transition-transform duration-300 hover:scale-105 hover:shadow-lg">
    {/* Profile Circle */}
    <div className="flex items-center justify-center mb-6">
      <div className="w-28 h-28 flex items-center justify-center rounded-full text-sm text-gray-700 font-medium overflow-hidden">
        {mentor.image ? (
          <img
            src={mentor.image}
            alt={mentor.name}
            className="w-full h-full rounded-full object-cover"
          />
        ) : (
          <span className="text-center px-2">{mentor.initials}</span>
        )}
      </div>
    </div>

    {/* Name & Title */}
    <h3 className="text-lg font-semibold text-red-800">{mentor.name}</h3>
    <p className="text-blue-800 text-sm font-medium mb-3">{mentor.title}</p>

    {/* Bio */}
    <p className="text-gray-600 text-sm leading-relaxed">{mentor.bio}</p>
  </div>
);

const Mentors = () => {
  const carouselRef = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (carouselRef.current) {
      setWidth(
        carouselRef.current.scrollWidth - carouselRef.current.offsetWidth
      );
    }
  }, []);

  return (
    <section id="team" className="w-full bg-gray-50 py-16 px-6 md:px-16">
      {/* Title */}
      <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-12">
        Meet Our Mentors
      </h2>

      {/* Mobile Carousel */}
      <div className="sm:hidden overflow-hidden">
        <motion.div
          ref={carouselRef}
          className="flex gap-6 cursor-grab active:cursor-grabbing"
          drag="x"
          dragConstraints={{ right: 0, left: -width }}
        >
          {mentors.map((mentor) => (
            <MentorCard key={mentor.id} mentor={mentor} />
          ))}
        </motion.div>
      </div>

      {/* Tablet & Desktop Grid */}
      <div className="hidden sm:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
        {mentors.map((mentor) => (
          <MentorCard key={mentor.id} mentor={mentor} />
        ))}
      </div>
    </section>
  );
};

export default Mentors;
